import React from 'react';
import {FaCircle} from "react-icons/fa";

const StatusCellRenderer = (params) => {
    const {value} = params;
    let color;

    if (value === 'ONLINE') {
        color = '#008a0e';
    } else if (value === 'OFFLINE') {
        color = '#ff4545';
    } else {
        color = '#999';
    }

    return (
        <div className={"m-auto"}>
            <FaCircle color={color} size={"18px"}/>
        </div>
    );
};

export default StatusCellRenderer;